module.exports = __webpack_public_path__ + "static/media/55_000065.d1195ba0.jpg";